import {useCallback} from 'react'
import {
  UpdateLocationCallbackType,
  useUrlUpdater
} from 'components/data/WithUrlUpdater'

import {LayoutType, MapDisplayAction} from '../../modules/search/types'

export enum MapButtonPosition {
  Floating = 'Floating'
}

const showMap = (updateLocation: UpdateLocationCallbackType) => {
  updateLocation({layout: LayoutType.MAP}, {basePath: window.location.pathname})
}

const showList = (updateLocation: UpdateLocationCallbackType) => {
  updateLocation(
    {layout: LayoutType.LIST},
    {basePath: window.location.pathname}
  )
}

const resetLayoutToDefault = (updateLocation: UpdateLocationCallbackType) => {
  updateLocation(
    {layout: undefined},
    {method: 'replace', basePath: window.location.pathname}
  )
}

export const useChangeMapLayout = () => {
  const {updateLocationShallow} = useUrlUpdater()

  /**
   * Dispatches the correct event to hide, show, expand or minimize the map
   * @param requestedAction - an action that we want the map to do
   * @param withSplitView - whether the split view should be shown for relevant situations
   */
  return useCallback(
    (requestedAction: MapDisplayAction, withSplitView: boolean) => {
      switch (requestedAction) {
        case MapDisplayAction.EXPAND:
          showMap(updateLocationShallow)
          break

        case MapDisplayAction.MINIMIZE:
          resetLayoutToDefault(updateLocationShallow)
          break

        case MapDisplayAction.HIDE:
          showList(updateLocationShallow)
          break

        case MapDisplayAction.SHOW:
          if (withSplitView) resetLayoutToDefault(updateLocationShallow)
          if (!withSplitView) showMap(updateLocationShallow)
          break

        default:
          break
      }
    },
    [updateLocationShallow]
  )
}
